import React from "react";
import { interpolate, useCurrentFrame } from "remotion";

export interface KineticBadgeProps {
  text: string;
  dotColor?: string;
  bgColor?: string;
  textColor?: string;
  borderColor?: string;
  style?: React.CSSProperties;
}

/**
 * KineticBadge Component
 * Pill badge modern dengan pulsing dot status & subtle glow.
 */
export const KineticBadge: React.FC<KineticBadgeProps> = ({
  text,
  dotColor = "#e8f36e",
  bgColor = "rgba(255,255,255,0.06)",
  textColor = "#d0dbd4",
  borderColor = "rgba(255,255,255,0.14)",
  style,
}) => {
  const frame = useCurrentFrame();

  const dotPulse = interpolate(
    Math.sin(frame / 12),
    [-1, 1],
    [0.4, 1.0]
  );

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        backgroundColor: bgColor,
        border: `1px solid ${borderColor}`,
        padding: "8px 18px",
        borderRadius: "100px",
        backdropFilter: "blur(12px)",
        ...style,
      }}
    >
      <div
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: dotColor,
          opacity: dotPulse,
          boxShadow: `0 0 12px ${dotColor}`,
        }}
      />
      <div
        style={{
          fontSize: "15px",
          fontWeight: 700,
          color: textColor,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
        }}
      >
        {text}
      </div>
    </div>
  );
};
